export const environment = {
    name: 'staging',
    production: true,
    apiUrl: window.location.origin + '/api',
    convexUrl: window.location.origin + '/convex',
};
